
<template>
	<div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" align="center"></compFormQuery>
			<compFormEdit v-else ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" align="center"/>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
        <div class="text-right">
            <vButton v-if="!query" theme="primary" class="width-15per" @click="submit">保存</vButton>
			<vButton class="width-15per margin-left-10" @click="cancel">返回</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpCarrierOne, HttpCarrierSave, HttpGetLog } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../fedexcost/mixin';

export default {
	mixins:[mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compTablelist: () => import("@components/templates/tablelist"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			detailList:[],
			formData: {
				// remark:'',
			}
		}
	},
	created() {
		// console.log(this.$route.params.type)
		this.query = this.type === "query";
		if (this.type == 'edit' || this.type == 'query') {
			this.getDetail()
		}
	},
	computed: {
		...mapGetters('dictionary', ['getWarehouseList', 'getOrgList','getCarrierServiceList']),
		getBase() {
            let showquery = this.type == 'query' || this.type=='edit'
			return [
				{
                    label: "组织",
                    key: "orgId",
                    tag: "vSelect",
					query: showquery,
					options: this.getOrgList,
					props: {
						filterable: true,
					}
                },
                {
					label: "仓库",
					key: "orgWarehouseId",
					tag: "vSelect",
                    query: showquery,
					options: this.getWarehouseList,
					props: {
						filterable: true,
					}
				},
				{
					label: "状态",
					key: "isInvalid",
					tag: "vSelect",
					options: [
                        {value:'isInvalid', label:'启用'},
                        {value:'noInvalid', label:'禁用'},
                    ],
					props: {
						filterable: true,
					}
				},
				{
					label: "是否自动测算",
					key: "isCalculation",
					tag: "vSelect",
					options: [
                        {value:'isCalculation', label:'是'},
                        {value:'noCalculation', label:'否'}
                    ],
					props: {
						filterable: true,
					}
                },
                {
                    label: "原Carrier",
					key: "carrierCode",
					tag: "vSelect",
                    query: showquery,
					options: this.getCarrierServiceList,
					props: {
						filterable: true,
					}
                },
				{
					label: "目标结算Carrier",
					key: "targetCarrierCode",
					tag: "vSelect",
					options: this.getCarrierServiceList,
					props: {
						filterable: true,
					}
				},
				{
					label: "是否Oversize",
					key: "isOversize",
					tag: "vSelect",
					options: [
                        {label: '是', value: 'isOversize'},
                        {label: '否', value: 'noOversize'},
                    ],
					props: {
						filterable: true,
					}
                },
			];
        },
	},
	methods: {
		async getDetail() {
            // if (this.type === 'add') return;
            this.loading = true;
            HttpCarrierOne({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});
			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:28,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{
	
				})
			}
		},
		handleResponse(data={}){
			this.formData = data
		},
		submit(){
			this.loading = true
			HttpCarrierSave({
				...this.formData
			}).then(res=>{
				this.loading = false
				this.$VMessage.success(res.message)
				this.cancel()
			},err=>{
				this.loading = false
			})
		},
		cancel(){
			this.$router.push({ name: "fedexCarrierList" })
		}	
	},
}
</script>
